// @flow

function ucwords (str) {
    return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
        return $1.toUpperCase();
    });
}

export function ffrName(name: string) {
    return name ? ucwords(name.toLowerCase())
        .replace('Xv ', 'XV ')
        .replace(' Xv', ' XV')
        .replace('A C B B ', 'ACBB ')
        .replace(' A C', ' AC')
        .replace('A C ', 'AC ')
        .replace(' Ac ', ' AC ')
        .replace('A S M ', 'ASM ')
        .replace('A S ', 'AS ')
        .replace('As ', 'AS ')
        .replace(' De ', ' de ')
        .replace('J A ', 'JA ')
        .replace('U M S', 'UMS ')
        .replace('U S ', 'US ')
        .replace(' U S', ' US')
        .replace(' Us ', ' US '
        .replace('U S O N', 'USON '))
        .replace('F C ', 'FC ')
        .replace('S C O R C', 'SCORC')
        .replace('S C U F', 'SCUF')
        .replace('S C ', 'SC ')
        .replace('R C ', 'RC ')
        .replace('Rc ', 'RC ')
        .replace(' R C', ' RC')
        .replace(' Rc ', ' RC ')
        .replace('C S ', 'CS ')
        .replace('S A ', 'SA ')
        .replace('C A ', 'CA ')
        .replace('C O ', 'CO ')
        .replace('C R ', 'CR ')
        .replace('R O ', 'RO ')
        .replace('Nicois', 'Niçois')
        .replace('Francais ', 'Français ')
        .replace('Cote D Or', 'Côte d\'Or')
        .replace('Federale', 'Fédérale')
        .replace(/ \(\d{4}.\)/g, '')
        .replace(/ \(\d+rst\)/g, '').trim() : '';
  }